import { useContext } from 'react';
import { NotificationContext } from './provider';
const useNotification = () => {
    return useContext(NotificationContext);
};
export default useNotification;
